import { render } from "./AmendBookingJourney.vue?vue&type=template&id=7b4b3ec8&scoped=true&lang=pug"
import script from "./AmendBookingJourney.vue?vue&type=script&lang=ts"
export * from "./AmendBookingJourney.vue?vue&type=script&lang=ts"

import "./AmendBookingJourney.vue?vue&type=style&index=0&id=7b4b3ec8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7b4b3ec8"

export default script